import { IonText, IonImg, IonItem, IonLabel } from "@ionic/react";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectLocation } from "../../../store/locationShow/selectors/selectLocation";
import api from "../../../utils/api";

export const HeaderSection: React.FC = () => {
  const location = useSelector(selectLocation);
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (location.picture) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${location.picture?.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setImageSrc(url);
          } else {
            console.error('Error fetching image:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchImage();
  }, [location.picture]);

  return (
    <section
      style={{
        position: "relative",
        height: "100px",
        background: "var(--ion-color-primary)",
      }}
    >
      {imageSrc && (
        <IonImg
          src={imageSrc}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "relative",
          }}
          alt="Imagen instalación"
        />
      )}
      <section
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          top: 0,
          paddingTop: 16,
          marginTop: 30,
          width: "100%",
          background:
            "linear-gradient(0deg, rgba(83,82,96,0.46682422969187676) 59%, rgba(138,138,138,0) 100%)",
        }}
      >
        <IonItem color="transparent" lines="none">
          <IonLabel>
            <h1>
              <IonText color={"light"} style={{ fontWeight: 500 }}>
                {location?.name} -{" "}
                <span style={{ fontSize: 14 }}>{location?.organization?.name}</span>
              </IonText>
            </h1>
          </IonLabel>
        </IonItem>
      </section>
    </section>
  );
};